import React from 'react';

export function Calendar(props) {
    return (
        <svg viewBox="0 0 90 91" {...props}>
            <path
                fillRule="evenodd"
                d="M64 17.49h7v-17h-7v17zm-45 0h7v-17h-7v17zm-9 23h70v40H10v-40zm70-30h-4.5v10h-16v-10h-29v10h-16v-10H10c-5.5 0-10 4.5-10 10v60c0 5.5 4.5 10 10 10h70c5.5 0 10-4.5 10-10v-60c0-5.5-4.5-10-10-10z"
            />
        </svg>
    );
}
